var Schema = require("lib/shared/Schema");
var APIClient = require("lib/web/APIClient");

export var RECEIVE_RECORDS = "RECEIVE_RECORDS";
export var REMOVE_RECORDS = "REMOVE_RECORDS";
export var REMOVE_ALL_RECORDS = "REMOVE_ALL_RECORDS";
export var UPDATE_RECORDS = "UPDATE_RECORDS";
export var LOADING_RECORDS = "LOADING_RECORDS";
export var CLEAR_LOADING_RECORDS = "CLEAR_LOADING_RECORDS";
export var INVALIDATE_CACHE = "INVALIDATE_CACHE";
export var RECEIVE_HELLO = "RECEIVE_HELLO";

export function receiveHello(data) {
	return {
		type: RECEIVE_HELLO,
		data: data,
	};
}

// Testing async pipeline and connection to server
export function fetchHello() {
	return dispatch => {
		return APIClient.getHello().then(json => dispatch(receiveHello(json)));
	};
}

function getCacheObject(cacheKey, queryOps) {
	if (cacheKey === true) {
		return queryOps;
	} else {
		return _.extend({}, queryOps, { key: cacheKey });
	}
}

export function receiveRecords(recordData, recordSchema, queryOps = {}, keyOps = {}) {
	if (keyOps.preSchemaF) {
		keyOps.preSchemaF(recordData);
	}
	var entities = Schema.entities(recordData, recordSchema);

	if (_.isEmpty(entities) && keyOps.reducer) {
		// Create an empty object to trigger actions in the reducers even
		// For empty arrays
		entities = { [keyOps.reducer]: {} };
	}

	var eventData = {
		type: RECEIVE_RECORDS,
	};

	eventData.metaReducer = keyOps.reducer;

	if (keyOps.mapRecordF) {
		entities = _.mapObject(entities, (items, key) => {
			return _.map(items, x => keyOps.mapRecordF(x, key));
		});
	}

	if ("loading" in keyOps) {
		eventData.loadingKeys = [keyOps.loading];
	}
	if (keyOps.cache) {
		eventData.cache = [getCacheObject(keyOps.cache, queryOps)];
	}
	if (keyOps.pagination) {
		eventData.pagination = keyOps.pagination;
		if (recordData[keyOps.reducer]) {
			var records = recordData[keyOps.reducer]
		} else {
			var records = _.first(_.values(recordData))
		}

		if (records && records.length < parseInt(recordData.per_page)) {
			eventData.noMorePages = true;
		}
	}

	var query = $wr.sortedJSON(queryOps.params || {});
	if ("total" in recordData) {
		eventData.totals = { [query]: recordData.total };
	}

	var receivedAt = Date.now();

	_.each(entities, (items, entityKey) => {
		eventData[entityKey] = _.map(items, item => {
			return _.extend({}, item, {
				receivedAt: receivedAt,
				embeds: queryOps.embeds,
			});
		});
	});

	return eventData;
}

// Generic action creator for async fetching multiple records
export function fetchRecords(fetchF, schema, queryOps = {}, keyOps = {}) {
	var query = _.clone(queryOps.params || {}); // Ok to be undefined
	if (queryOps.embeds && queryOps.embeds.length > 0) {
		query.embed = queryOps.embeds.join(",");
	}

	if (queryOps.page !== undefined) {
		query.page = queryOps.page;
	}

	return (dispatch, getState) => {
		if (keyOps.reducer && keyOps.cache) {
			var cacheObject = getCacheObject(keyOps.cache, queryOps);

			var scopeData = getState()[keyOps.reducer];
			if (scopeData && inIndexCache(cacheObject, scopeData.cached)) {
				return Promise.resolve();
			}
		}

		if (keyOps.reducer && keyOps.loading) {
			dispatch(loadingRecords(keyOps.reducer, keyOps.loading));
		}
		return fetchF(query).then(data => {
			if (data.patches) {
				data.patches = data.patches.map(patch => ({
					...patch,
					id: `${patch.patch_type}-${patch.name}`,
				}));
			}
			if (data.perks) {
				data.perks = data.perks.map(perk => ({
					...perk,
					id: `${perk.perk_type}-${perk.name}`,
				}));
			}
			if (query.furniture_only === true) {
				data.furnitures = data.perks;
				data.perks = null;
			}
			return dispatch(receiveRecords(data, schema, queryOps, keyOps));
		});
	};
}

export function fetchRecord(fetchF, recordID, schema, queryOps = {}, keyOps = {}) {
	var query = _.clone(queryOps.params || {}); // Ok to be undefined
	if (queryOps.embeds) {
		query.embed = queryOps.embeds.join(",");
	}

	if (queryOps.page !== undefined) {
		query.page = queryOps.page;
	}

	return (dispatch, getState) => {
		if (keyOps.reducer && keyOps.cache) {
			var cacheObject = getCacheObject(keyOps.cache, queryOps);

			var scopeData = getState()[keyOps.reducer];
			if (scopeData && inIndexCache(cacheObject, scopeData.cached)) {
				return Promise.resolve();
			}
		}

		if (keyOps.reducer && keyOps.loading) {
			loadingRecords(keyOps.reducer, keyOps.loading); // Greg in 2020, no idea why this is here
			// Dispatch event to record the loading state
			// Example action: { type: "LOADING_RECORDS", quizzes: "all" }
			dispatch({ type: LOADING_RECORDS, [keyOps.reducer]: keyOps.loading });
		}
		return fetchF(recordID, query).then(data =>
			dispatch(receiveRecords(data, schema, queryOps, keyOps)),
		);
	};
}


export function clearLoadingRecords(reducer) {
	return (dispatch, getState) => {
		return dispatch({ type: CLEAR_LOADING_RECORDS, [reducer]: true });
	}
}

export function setLoadingRecords(reducer, loadingKey) {
	return (dispatch, getState) => {
		return dispatch({ type: LOADING_RECORDS, [reducer]: loadingKey });
	}
}

/////////////////////////////
//////// Utility ////////////
/////////////////////////////

// Dispatch event to record the loading state
// Example action: { type: "LOADING_RECORDS", quizzes: "all" }
function loadingRecords(reducer, loadingKey) {
	return { type: LOADING_RECORDS, [reducer]: loadingKey };
}


function inIndexCache(newCache, cachedQueryOps) {
	return _.any(cachedQueryOps, ({ params, embeds, page, key }) => {
		// Query, page, and key must be exact matches
		if (!_.isEqual(newCache.params, params) || newCache.page != page || newCache.key != key) {
			return false;
		}

		// There can't be any embeds in newCache not already in the cached embeds
		return _.difference(newCache.embeds, embeds).length == 0;
	});
}



// WEBPACK FOOTER //
// ./modules/lib/shared/ActionUtility.js